import { gql } from 'graphql-request';

export const GET_TALENT_MEMBERS = gql`
  query ($search: String, $age: Int, $gender: String) {
    talents(search: $search, age: $age, gender: $gender) {
      id
      email
      first_name
      last_name
      picture
      stage_name
      user_types
    }
  }
`;

export const MY_DATA = gql`
  query ($id: ID!) {
    talent(id: $id) {
      id
      gender
      identifies_as
      statistics
      adult_minor
      unions
      sag_id
      sag_status
      general
      country
      user_types
      profiles {
        id
      }
    }
  }
`;

export const TALENT_CALENDAR_EVENTS = gql`
  query (
    $first: Int
    $after: String
    $date_from: ISO8601Date
    $date_to: ISO8601Date
    $talent_ids: [ID!]
    $search: String
  ) {
    calendar_events_connection(
      first: $first
      after: $after
      dateFrom: $date_from
      dateTo: $date_to
      talentIds: $talent_ids
      search: $search
    ) {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      nodes {
        id
        talent {
          id
        }
        title
        company_name
        role_name
        project_name
        location
        event_type
        notes
        start_datetime
        end_datetime
        all_day
        # start_time
        # end_time
        repeats
        occurrences {
          happening_at
          ends_at
        }
        repeats_details
      }
    }
  }
`;

export const TALENT_SEARCH_CALENDAR_EVENTS = gql`
  query ($first: Int, $after: String, $talent_ids: [ID!], $search: String) {
    calendar_events_connection(first: $first, after: $after, talentIds: $talent_ids, search: $search) {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      nodes {
        id
        title
        event_type
        start_datetime
        end_datetime
        all_day
        repeats
      }
    }
  }
`;
